import React from 'react';
import { CenteredFlexBox, FullSizeColumn } from '../../FlexBox';
import CaptionValue from '../../CaptionValue/CaptionValue';
import { culture } from '../../../Helpers/dates';
import { Typography } from '@mui/material';
import Chip from '../../Chip';

const DetailsContent = function DetailsContent({
  completedByFullName,
  completedOn,
  outcomeName,
  campaignAdvancement,
}) {
  return (
    <FullSizeColumn padding="16px" minHeight="100px" gap="16px">
      <CaptionValue
        captionStyle={{ textTransform: 'uppercase', fontWeight: 'bold' }}
        captionColor="primary"
        caption="COMPLETEDBY"
        value={completedByFullName}
      />
      <CaptionValue
        captionStyle={{ textTransform: 'uppercase', fontWeight: 'bold' }}
        captionColor="primary"
        caption="COMPLETEDON"
        value={new Date(completedOn).toLocaleString(culture, {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
        })}
      />
      <CaptionValue
        captionStyle={{ textTransform: 'uppercase', fontWeight: 'bold' }}
        captionColor="primary"
        caption="OUTCOME"
        value={
          <CenteredFlexBox gap="8px">
            <Typography variant="body1">{outcomeName}</Typography>
            <Chip
              id={`${outcomeName}-call-percentage`}
              variant="outlined"
              label={`${campaignAdvancement}%`}
              color="#1D5B9D"
              fontSize="1.5rem"
            />
          </CenteredFlexBox>
        }
      />
    </FullSizeColumn>
  );
};
export default DetailsContent;
